import React, { useState, useRef, Fragment } from "react"

import { useNavigate } from 'react-router-dom'
import { Product } from '../types'

import { 
  Box, TextField, CircularProgress, List, ListItem, ListItemButton, ListItemText, ListSubheader,
  InputAdornment, Chip, InputLabel, Paper, FilledInput, IconButton
} from '@mui/material'

import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import NotInterestedIcon from '@mui/icons-material/NotInterested'

import BottomNavBar from '../Essentials/NavBar'

import { indexOf, isEmpty, isNil, toLower } from "ramda"

import { MpnLookupRequest, MpnLookupResult } from "../types"
import { fetchProducts, getContractsForMpnLookup, } from './utils'
import MpnContractResults from './SingleMpnLookupResult'

import { RequireAuth, useAuthHeader, useAuthUser } from "react-auth-kit"

import { ThemeProvider, createTheme } from '@mui/material/styles'

import { useDebouncedCallback } from 'use-debounce'

import "../App.css"



/* TO DO: Add proper types to the state setters */

type GetProductsProps = {
  authToken?: string
  setProducts: any
  setIsViewingProducts: any
  setIsFetchingProducts: any
  setErrorDetails: any 
  navigate: any
}

const getProducts = (props: GetProductsProps) => (searchBarVal: string) : any => {
  
  /* Do not make an empty fetch to the DB, this will return all products */
  if (isEmpty(searchBarVal))
     return props.setProducts([])

  props.setIsFetchingProducts(true)

  const productsProm = fetchProducts(searchBarVal, props.authToken)
    
    productsProm
    .then(res => {


      if (res.status >= 400){
  
        console.error('400+ Response Status')
        
        return res.json()
          .then(res => {
  
            return { 
              badRequest: true, 
              message: res.message || 'Something Unexpected Went Wrong!',
              invalidToken: res.invalidToken
            }
        
          }) 
  
          
        }
  
      return res.json()

    })
    .then(res => {
        
      if (res.badRequest){

        /* 
          If the request is bad because of an invalid token, we redirect to the login page
        */
        if (res.invalidToken)
          return props.navigate('/login')

        props.setIsFetchingProducts(false)
        props.setErrorDetails({ 
          hasError: true, message: res.message || 'Something Unexpected Went Wrong!' 
        })
        return
      }
     
      console.log('Response', res)

      const { search, products } = res

      props.setProducts(products)
      props.setIsViewingProducts(true)
      props.setIsFetchingProducts(false)

  })
  .catch((e) => {
    console.error('Error : ', e)
    props.setIsFetchingProducts(false)
    props.setErrorDetails({ hasError: true, message: 'Something Unexpected Went Wrong!' })
  })
}

type GetContractsProps = {
  authToken?: string
  setLookupResults: any
  setIsFetchingContracts: any
  setErrorDetails: any 
  navigate: any
}

const getContractsForProduct = (props: GetContractsProps, date: string | Date) => 
(selectedProduct: Product) => {

  props.setIsFetchingContracts(true)
  

  const mpn = selectedProduct?.vendor_item_id || ''
  const vendor = selectedProduct?.vendor || ''

  const lookup: MpnLookupRequest = { mpn, vendor, date }

  const contractsProm = getContractsForMpnLookup(lookup, props.authToken)

  contractsProm
    .then(res => {


      if (res.status >= 400){
  
        console.error('400+ Response Status')
        
        return res.json()
          .then(res => {
  
            return { 
              badRequest: true, 
              message: res.message || 'Something Unexpected Went Wrong!',
              invalidToken: res.invalidToken
            }
        
          }) 
  
          
        }
  
      return res.json()

    })
    .then(res => {
        
      if (res.badRequest){

        /* 
          If the request is bad because of an invalid token, we redirect to the login page
        */
        if (res.invalidToken)
          return props.navigate('/login')

        props.setLookupResults([])
        props.setIsFetchingContracts(false)
        props.setErrorDetails({ 
          hasError: true, message: res.message || 'Something Unexpected Went Wrong!' 
        })
        return
      }
     
      console.log('Response', res)
        
      const lookupResults : MpnLookupResult[] = res

      props.setLookupResults(lookupResults)
      props.setIsFetchingContracts(false)
  })
  .catch((e) => {
    console.error('Error : ', e)
    props.setLookupResults([])
    props.setIsFetchingContracts(false)
    props.setErrorDetails({ hasError: true, message: 'Something Unexpected Went Wrong!' })
  })

}

const ProductsLoader = () => (
  <CircularProgress />
)

const ContractsLoader = () => {
    return (
      <Box sx={{ display: 'flex',  position: 'fixed',
      top: '55%',
      left: '50%',
      }}>
          <CircularProgress />
      </Box>
    )
  }

  type SelectedProductProps = {
    product: Product
    isFetchingContracts: any
    setSelectedProduct: any
    setIsViewingProducts: any
    setLookupResults: any
  }

  const SelectedProduct = (props: SelectedProductProps) => {

    const isFetchingContracts = props.isFetchingContracts || false

    const { vendor, vendor_item_id, item_description } = props.product
  
    // const rowTheme = createTheme({
      
    //   over
    // })

    return (
      <Box 
      component='div'
      sx={{ 
// margin: '5px', 
      width: '100%',
      borderRadius: '30px',
      display: 'flex',
      // margin: '0 auto 3% auto'
    }}
    >
      <TextField 
        InputProps={{
          readOnly: true,
          disableUnderline: true,
          sx: { 
          fontSize: '14px',  
          // margin: 0,
          // borderWidth: '1px 0 1px 1px',
          // borderRadius: 1
        }
        }} 
        disabled
        value={`${vendor}`}
        label="Vendor"
        type="text" 
        variant='standard'

        sx={{ 
          flex: '20%', 
          textAlign: 'left', 
          // borderRadius: '0px 0px 0px 0px',
          // display:table-cell;
          // margin: 0,
          borderWidth: '1px 0 1px 1px'
        }}
      />

    <TextField 
        // primary={`${vendor}`}
        InputProps={{
          readOnly: true,
          disableUnderline: true,
          sx: { 
            fontSize: '14px',  
            // margin: 0, 
            // borderWidth: '1px 0 1px 1px'
          }
        }} 
        disabled
        value={`${vendor_item_id}`}
        label="MPN"
        type="text" 
        variant='standard'

        sx={{ 
          flex: '10%', textAlign: 'left', 
          // borderRadius: '0px 0px 0px 0px',
          // margin: 0,
          // borderWidth: '1px 1px 1px 0'
        }}
      />
     <TextField 
          disabled
          value={`${item_description}`}
          label="Item Description"
          type="text" 
          // variant="filled"           
          variant='standard'
          sx={{ 
            flex: '60%', textAlign: 'left', 
            // borderRadius: '0px 0px 0px 0px',
            // borderWidth: '1px 0', 
            margin: 0
          }}
        InputProps={{
          readOnly: true,
          disableUnderline: true,
          
          sx: { 
            fontSize: '14px'
          },
        //   endAdornment: (
        //     <IconButton
        //     onClick={() => {
        //       props.setSelectedProduct(null) 
        //       props.setIsViewingProducts(true)
        //       props.setLookupResults([])
        //     }} 
        //     disabled={isFetchingContracts}
        //     // onMouseDown={handleMouseDownPassword}
        //     // edge="end"
        //   >
        //     <HighlightOffIcon sx={{ width: '100%' }}/>
        // </IconButton>
        //   )
        }} 

        
      />
      
      <IconButton
            onClick={() => {
              props.setSelectedProduct(null) 
              props.setIsViewingProducts(true)
              props.setLookupResults([])
            }} 
            disabled={isFetchingContracts}
            sx={{ 
              flex: '10%'
            }}
            // onMouseDown={handleMouseDownPassword}
            // edge="end"
          >
            <HighlightOffIcon />
        </IconButton>
     </Box>
        // </Box>
  
    
    )
  
  }
  
   
type ProductListProps = {
  products: Product[]
  searchBarVal: string
  setSelectedProduct: any 
  setIsViewingProducts: any 
  getContractsForProduct: any
}

const ProductList = (props: ProductListProps) => {

  const { products = [], searchBarVal } = props

  const ProductListHeader = () => (
    <ListSubheader 
      key={'product-header'} 
      component="div"  
      sx={{ 
        marginTop: 0,
        display: 'flex',
        color: '#212121', 
        height: 45 
      }}
      
    >
     <ListItemText primary={`Vendor`} disableTypography 
        sx={{ flex: '35%', textAlign: 'left', fontSize: '12px'}}
        />
      <ListItemText primary={`MPN`} disableTypography 
      sx={{ flex: '15%', textAlign: 'left', fontSize: '12px' }} 
      />
      <ListItemText primary={`Item Description`} disableTypography 
        sx={{ flex: '50%', textAlign: 'left', fontSize: '12px' }}
      />
    </ListSubheader>
  )


  return (
    <Paper elevation={3} 
    sx={{
      marginTop: 0,
      width: '85%',
      margin: '0 auto',
      bgcolor: 'background.paper',
      textAlign: 'center',
      overflow: 'auto',
      maxHeight: 300,
      zIndex: 100,
      borderColor: '#424242',
      borderRadius: '5px 5px 5px 5px',
      // border: '0.5px solid'
    }}      
      >
        <List
        key={'product-list'}
    sx={{
      width: '100%',
      marginTop: 0,
      margin: '0 auto',
      bgcolor: 'background.paper',
      textAlign: 'center',
      overflow: 'auto',
      maxHeight: 300,
      zIndex: 100,
      borderColor: '#424242',
      borderRadius: '5px 5px 5px 5px',
      // border: '0.5px solid'
    }}
  >
    <ProductListHeader />
    {
    products.map((product: Product, index: number) => {

      const { vendor, vendor_item_id, item_description } = product


      /* Review this : Maybe make imperative to be safe, or with a reduce function */
      type SubstringObject = {
        str: string
        shouldBeBold: boolean
      }
      
      const splitIntoObjs = (search: string, strToSplit: string, acc: SubstringObject[]): 
        SubstringObject[] => {
  
        if (isEmpty(search))
          return [{ str: strToSplit, shouldBeBold: false }]

        if (isEmpty(strToSplit))
          return acc
      
       const nextInd = indexOf(toLower(search), toLower(strToSplit))
      
       if (nextInd == -1)
         return [...acc, { str: strToSplit, shouldBeBold: false }]
        
       const leftOfOccurr = strToSplit.substring(0, nextInd)
       const nextOccurr = strToSplit.substring(nextInd, nextInd + search.length)
       const updatedAcc = [
         ...acc, 
         { str: leftOfOccurr, shouldBeBold: false },
         { str: nextOccurr, shouldBeBold: true },
       ]
       const restOfStrToSplit = strToSplit.substring(nextInd + search.length, strToSplit.length)
       
       return splitIntoObjs(search, restOfStrToSplit, updatedAcc)
      
      }

      const mpnSplitIntoSubstr = splitIntoObjs(searchBarVal, vendor_item_id, [])
      const descriptionSplitIntoSubstr = splitIntoObjs(searchBarVal, item_description, [])
   
      return (
        <ListItem 
          /* All rows have divider except the last one */
          divider={index != (products.length - 1)}
          key={index} 
          component="div" 
          disablePadding
          sx={{ 
            display: 'block',
            color: '#757575',
            textAlign: 'center',
            // fontSize: 10,
            height: 40,
            '&:hover': { backgroundColor: '#424242' }

          }}
          >
        <ListItemButton 
      
          sx={{ 
            '&:hover': { backgroundColor: '#424242' },
            height: 40
          }}
          onMouseDown={() => {
            props.setSelectedProduct(product)
            props.setIsViewingProducts(false)
            props.getContractsForProduct(product)

            }} 
          
          >
          <ListItemText
            // primary={`${vendor}<b>Bold</b>`} 
            disableTypography
            sx={{ flex: '35%', textAlign: 'left', fontSize: '12px' }} 
          >
            {vendor}
          </ListItemText>
          <ListItemText 
            // primary={`${vendor_item_id}`} 
            disableTypography
            sx={{ flex: '15%', textAlign: 'left', fontSize: '12px' }} 
            >
              <span>
                {mpnSplitIntoSubstr.map(({ str, shouldBeBold }) => (
                     shouldBeBold ? <b style={{ fontSize: '12px', color: '#212121'}}>{str}</b> : str
                ))}
              </span>
            </ListItemText>
          <ListItemText 
            // primary={`${item_description}`} 
            disableTypography
            sx={{ flex: '50%', textAlign: 'left', fontSize: '12px' }} 
            >
                 <span>
                 {descriptionSplitIntoSubstr.map(({ str, shouldBeBold }) => (
                     shouldBeBold ? <b style={{ fontSize: '12px', color: '#212121' }}>{str}</b> : str
                ))}
              </span>
            </ListItemText>
            
        </ListItemButton>
      </ListItem>
      )
    })
  }
    
  </List>
    </Paper>

  )
}

type ProductSearchProps = {

  searchBarVal: string
  setSearchBarVal: any

  debouncedGetProducts: any
  selectedProduct: Product | null
  setSelectedProduct: any

  isFetchingProducts: any
  setIsViewingProducts: any

  isFetchingContracts: any

  setLookupResults: any
}

const ProductSearchBar = (props: ProductSearchProps) => {

  const { 
    selectedProduct,  setSelectedProduct, searchBarVal, setSearchBarVal,
    isFetchingProducts, setIsViewingProducts, debouncedGetProducts,
    isFetchingContracts, setLookupResults

  } = props

  const handleEnter = (e: any) => {
    if (e.key === 'Enter'){
      e.preventDefault()
        return 
      }
    }

  return (
    <TextField
              // label="Search Product"
              id='single-mpn-search-box'
              placeholder={!isNil(selectedProduct) ? '' : 'Search For Product'}
              value={!isNil(selectedProduct) ? '' : searchBarVal}
              type="text" 
              variant='filled'
              autoFocus={true} 
              autoComplete='off'
              fullWidth={false}
              onKeyPress={handleEnter}
              onFocus={() => { setIsViewingProducts(true) }}
              onBlur={() => { setIsViewingProducts(false) }}
              // disabled={isFetchingProducts || !isNil(selectedProduct)}

              onChange={({ target: { value } }) => {
                /* Set the search bar value immediately */
                setSearchBarVal(value)

                debouncedGetProducts(value)
                
              }}
              sx={{ 
                margin: '5px', 
                width: '100%',
                borderRadius: '30px'
             }}
              
              InputProps={{
                ...(isFetchingProducts ? { 
                  endAdornment: <InputAdornment position='end'>
                    <ProductsLoader /> 
                    </InputAdornment>} : {}
                  ),

                ...(!isNil(selectedProduct) ? { 
                  startAdornment:   (
                    <InputAdornment position="start" sx={{ width: '100%' }}>
                    <SelectedProduct 
                      product={selectedProduct} 
                      isFetchingContracts={isFetchingContracts}
                      setSelectedProduct={setSelectedProduct}
                      setIsViewingProducts={setIsViewingProducts}
                      setLookupResults={setLookupResults}
                    />
                    </InputAdornment>

                  )
                } : {}),

              }}
                       
            /> 
  )
            
}

const SingleMpnLookup = () => {

  const auth = useAuthUser()
  const authToken = auth()?.token || null
  const navigate = useNavigate()

  /* The value showing in the current search bar */
  const [searchBarVal, setSearchBarVal] = useState('')

  const [selectedProduct, setSelectedProduct] = useState(null as (Product | null))

  const [products, setProducts] = useState([])

  const [isViewingProducts, setIsViewingProducts] = useState(false)
  const [isFetchingProducts, setIsFetchingProducts] = useState(false)

  const [date, setDate] = useState<Date>(new Date())

  const [lookupResults, setLookupResults] = useState([] as MpnLookupResult[])
  const [isFetchingContracts, setIsFetchingContracts] = useState(false)

//   const [vendorName, setVendorName] = useState('')

  const [errorDetails, setErrorDetails] = useState({ hasError: false, message: '' })

  const debouncedGetProducts = useDebouncedCallback(
    getProducts({ 
      authToken, setProducts, setIsViewingProducts, setIsFetchingProducts, setErrorDetails, 
      navigate
    }), 
    600
    )


  return (
    <RequireAuth loginPath="/login">

    <div className="App">
        <div>
     
          {/* <div> */}
            {/* <h2 style={{ textAlign: 'left' }}>Contract Lookup : Product</h2> */}
            <div style={{ marginTop: '5%'}} >

            <Box 
              sx={{ 
        // margin: '5px', 
              marginTop: '10%',
              width: '85%',
              borderRadius: '30px',
              display: 'flex',
              margin: '0 auto 3% auto'
            }}
            >
              {
              !isNil(selectedProduct) ?  <SelectedProduct 
                      product={selectedProduct} 
                      isFetchingContracts={isFetchingContracts}
                      setSelectedProduct={setSelectedProduct}
                      setIsViewingProducts={setIsViewingProducts}
                      setLookupResults={setLookupResults}
                      
                    />
              : <ProductSearchBar 
                  selectedProduct={selectedProduct}  setSelectedProduct={setSelectedProduct} 
                  searchBarVal={searchBarVal} setSearchBarVal={setSearchBarVal}
                  isFetchingProducts={isFetchingProducts} 
                  setIsViewingProducts={setIsViewingProducts} 
                  debouncedGetProducts={debouncedGetProducts}
                  isFetchingContracts={isFetchingContracts} 
                  setLookupResults={setLookupResults}
          
              
                />}
            </Box>
            
            {isViewingProducts && !isFetchingProducts && !isEmpty(products) &&
              <ProductList 
                products={products.slice(0, 100)}
                searchBarVal={searchBarVal}
                setSelectedProduct={setSelectedProduct}
                setIsViewingProducts={setIsViewingProducts}
                getContractsForProduct={getContractsForProduct(
                  { authToken, setLookupResults, setIsFetchingContracts, setErrorDetails, navigate },
                  date)
                }
                />
              
              }
              {isViewingProducts && 
              !isFetchingProducts && 
              !isEmpty(searchBarVal) && 
               isEmpty(products) &&
                <Box 
                sx={{ 
                  width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center',
                  marginTop: '10%' 
              }} 
                >
                  <NotInterestedIcon sx={{ width: '5%', height: '5%'}} />
                  <span style={{ 
                    font: '12px', color: '#424242', marginTop: '1%'
                    }}>No Products Found</span>
                </Box>
              }
            </div>
      

            

            {/* <TextField
              id="select-vendor"
              select
              label="Vendor"
              sx={{ width: 250, margin: '5px' }}
              required
              value={vendorName}
              // defaultValue={vendorName}
              onChange={({ target: { value } }) => setVendorName(value)}

              // helperText="Please select vendor"
            >
          {vendor_names.map((vendorName) => (
            <MenuItem key={vendorName} value={vendorName}>
              {vendorName}
            </MenuItem>
          ))}
        </TextField> */}

            {/* <LocalizationProvider dateAdapter={AdapterDateFns} >
              <DatePicker
                label="Date"
                value={date}
                
                onChange={(picked: Date | null) => {
                  // console.log("picked", picked?.valueOf())
                  setDate(picked || new Date())
                }}
                renderInput={
                  (params: JSX.IntrinsicAttributes & TextFieldProps) => (
                  <TextField 
                    {...params} 
                    // onClick={() => }
                    onKeyDown={e => e.preventDefault()} 
                    sx={{ margin: '5px' }} 
                    required 
                    />
                  )}
              />
            </LocalizationProvider> */}
            
            
            
            </div>

          {/* <br /> */}

          {/* <LoadingButton 
            type="submit" 
            variant="contained" 
            disabled={isNil(selectedProduct)}
            loading={loading}
            >
            Get Contracts
          </LoadingButton> */}
        {/* </form>  */}
        {/* </div> */}

     

      <div>
        {isFetchingContracts && <ContractsLoader />}
        {!isFetchingContracts && !isNil(selectedProduct) && !isEmpty(lookupResults) && 
        <MpnContractResults 
        lookupResult={lookupResults[0]}
        />
        }
        
        {errorDetails.hasError &&  
            <div className="dangerMsg">
                <span>{errorDetails.message}</span>
                <button 
                    className="hoverable"
                    onClick={() => {
                      setErrorDetails({ hasError: false, message: '' })
                    }}
                >X</button>
            </div>
        }
      </div>
      <BottomNavBar />
      </div>

    </RequireAuth>
  )

      
}


    
        
export default SingleMpnLookup




// const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
//   e.preventDefault()
//   setLoading(true)
  

//   const mpn = selectedProduct?.vendor_item_id || ''
//   const vendor = selectedProduct?.vendor || ''

//   const lookup: MpnLookupRequest = { mpn, vendor, date }

//   const contractsProm = getContractsForMpnLookup(lookup)

//   contractsProm
//     .then(res => {


//       if (res.status >= 400){
  
//         console.error('400+ Response Status')
        
//         return res.json()
//           .then(res => {
  
//             return { 
//               badRequest: true, 
//               message: res.message || 'Something Unexpected Went Wrong!',
//               invalidToken: res.invalidToken
//             }
        
//           }) 
  
          
//         }
  
//       return res.json()

//     })
//     .then(res => {
        
//       if (res.badRequest){

//         /* 
//           If the request is bad because of an invalid token, we redirect to the login page
//         */
//         if (res.invalidToken)
//           return navigate('/login')

//         setLookupResults([])
//         setLoading(false)
//         setErrorDetails({ 
//           hasError: true, message: res.message || 'Something Unexpected Went Wrong!' 
//         })
//         return
//       }
     
//       console.log('Response', res)
        
//       const lookupResults : MpnLookupResult[] = res

//       setLookupResults(lookupResults)

//       setLoading(false)
//   })
//   .catch((e) => {
//     console.error('Error : ', e)
//     setLookupResults([])
//     setLoading(false)
//     setErrorDetails({ hasError: true, message: 'Something Unexpected Went Wrong!' })
//   })

// }
  
// const handleEnter = (e: any) => {
    
//   if (e.key === 'Enter'){
//     e.preventDefault()
//       return 

//     setIsFetchingProducts(true)

//     const productsProm = getProducts(searchBarVal)
    
//     productsProm
//     .then(res => {


//       if (res.status >= 400){
  
//         console.error('400+ Response Status')
        
//         return res.json()
//           .then(res => {
  
//             return { 
//               badRequest: true, 
//               message: res.message || 'Something Unexpected Went Wrong!',
//               invalidToken: res.invalidToken
//             }
        
//           }) 
  
          
//         }
  
//       return res.json()

//     })
//     .then(res => {
        
//       if (res.badRequest){

//         /* 
//           If the request is bad because of an invalid token, we redirect to the login page
//         */
//         if (res.invalidToken)
//           return navigate('/login')

//         setIsFetchingProducts(false)
//         setErrorDetails({ 
//           hasError: true, message: res.message || 'Something Unexpected Went Wrong!' 
//         })
//         return
//       }
     
//       console.log('Response', res)

//       setProducts(res)
//       setIsViewingProducts(true)
//       setIsFetchingProducts(false)
//   })
//   .catch((e) => {
//     console.error('Error : ', e)
//     setIsFetchingProducts(false)
//     setErrorDetails({ hasError: true, message: 'Something Unexpected Went Wrong!' })
//   })

// }
// }

  // return (
    //   <Chip 
    //     label={`VENDOR : ${vendor} | MPN : ${vendor_item_id}  | ITEM DESCRIPTION : ${item_description}`} 
    //     sx={{ height: '100%', width: '100%' }}
    //     onDelete={() => {
    //       props.setSelectedProduct(null) 
    //       props.setIsViewingProducts(true)
    //       props.setLookupResults([])
    //     }} 
    //     disabled={isFetchingContracts}
    //     />
    // )